
import React from 'react';
import { Answer } from '@/types/assessment';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SliderAnswersProps {
  categoryId: string;
  questionId: string;
  answers: Answer[];
  onUpdateAnswer: (categoryId: string, questionId: string, answerId: string, updates: Partial<Answer>) => void;
}

export function SliderAnswers({ 
  categoryId, 
  questionId, 
  answers, 
  onUpdateAnswer 
}: SliderAnswersProps) {
  return (
    <div className="space-y-2">
      <Label>Slider Configuration</Label>
      <p className="text-sm text-muted-foreground">
        Slider questions use the first option as the minimum value and the second option as the maximum value.
      </p>
      <div className="grid grid-cols-2 gap-4">
        {answers.slice(0, 2).map((answer, index) => (
          <div key={answer.id}>
            <Label>{index === 0 ? 'Minimum Value' : 'Maximum Value'}</Label>
            <div className="flex items-center gap-3 mt-1">
              <div className="flex-1">
                <Input
                  value={answer.text}
                  onChange={(e) => onUpdateAnswer(
                    categoryId, 
                    questionId, 
                    answer.id, 
                    { text: e.target.value }
                  )}
                  placeholder={index === 0 ? "Min label" : "Max label"}
                />
              </div>
              <div className="w-20">
                <Input
                  type="number"
                  value={answer.value}
                  onChange={(e) => onUpdateAnswer(
                    categoryId, 
                    questionId, 
                    answer.id, 
                    { value: Number(e.target.value) }
                  )}
                  placeholder="Value"
                  min={index === 0 ? "0" : "1"}
                  max="10"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
